import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState, useContext } from 'react';
import BookingService from './bookings/BookingService';
import AppContext from 'context/Context';
const AttendanceHeatmapCard = ({ data }) => {
  const [heatmapData, setHeatmapData] = useState([]);
  const [bookigsData, setBookigsData] = useState([]);
  const [stats, setStats] = useState({
    thisYear: 0,
    thisMonth: 0,
    thisWeek: 0,
    currentStreak: 0
  });
    const {
      config: { isDark }
    } = useContext(AppContext);
  const [weeks, setWeeks] = useState([]);
  useEffect(() => {
    BookingService.retrieveAllBookingsByUser()
      .then(data => {
        const updatedStats = {
          thisYear: data.filter(booking => {
            const bookingDate = new Date(booking.date);
            return bookingDate.getFullYear() === new Date().getFullYear();
          }).length,
          thisMonth: data.filter(booking => {
            const bookingDate = new Date(booking.date);
            return (
              bookingDate.getFullYear() === new Date().getFullYear() &&
              bookingDate.getMonth() === new Date().getMonth()
            );
          }).length,
          thisWeek: data.filter(booking => {
            const bookingDate = new Date(booking.date);
            const currentDate = new Date();
            const firstDayOfWeek = new Date(
              currentDate.setDate(currentDate.getDate() - currentDate.getDay())
            );
            const lastDayOfWeek = new Date(
              currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6)
            );
            return bookingDate >= firstDayOfWeek && bookingDate <= lastDayOfWeek;
          }).length,
          currentStreak: (() => {
            let streak = 0;
            const today = new Date();
            for (let i = 0; i < 7; i++) {
              const dateToCheck = new Date(today);
              dateToCheck.setDate(today.getDate() - i);
              const dateString = dateToCheck.toISOString().split('T')[0];
              if (data.some(booking => booking.date === dateString)) {
                streak++;
              } else {
                break;
              }
            }
            return streak;
          })()  
        };
        
        const updatedDays = data.map(record => ({
          count: 1,
          date: new Date(record.date).toISOString().split('T')[0]
        }));

        setStats(updatedStats);
        const updatedHeatmapData = generateHeatmapData(updatedDays);
        setHeatmapData(updatedHeatmapData);
        setWeeks(getWeeks(updatedHeatmapData));
      })
      .catch(error => console.log(error));
  }, []);

  const generateHeatmapData = bookingsData => {
    console.log('Generating heatmap data from bookings:', bookingsData);
    const data = [];
    const today = new Date();
    for (let i = 364; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);

      data.push({
        date: date.toISOString().split('T')[0],
        count: bookingsData.some(booking => booking.date === date.toISOString().split('T')[0])
          ? 1
          : 0
      });
    }
    return data;
  };

  // Group data by week
  const getWeeks = heatmapData => {
    const weeks = [];
    let currentWeek = [];

    // Show last 20 weeks for better visibility
    const recentData = heatmapData.slice(-140);
    console.log('Recent Data for Heatmap:', recentData);
    recentData.forEach((day, index) => {
      currentWeek.push(day);
      if (currentWeek.length === 7) {
        weeks.push([...currentWeek]);
        currentWeek = [];
      }
    });
    console.log('Weeks for Heatmap:', weeks);
    return weeks;
  };

  const getColorForCount = count => {
    if (count === 0 && isDark) return 'rgba(255,255,255,0.05)';
    if (count === 0 && !isDark) return 'rgba(0,0,0,0.1)';
    if (count === 1 && isDark) return 'rgba(34,197,94,0.4)';
    if (count === 1 && !isDark) return 'rgba(34,197,94,0.4)';
    return 'rgba(34,197,94,0.8)';
  };

  return (
    <Card className="h-100 border-0 shadow-sm wod-dark-card">
      <Card.Header className="bg-transparent border-bottom border-secondary">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faCalendar} className="text-success me-2" />
            <h5 className="mb-0 fw-bold">Training Consistency</h5>
          </div>
          <div className="text-end">
            <div className="fw-bold text-success">{stats.thisYear}</div>
            <small >classes this year</small>
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between mb-3">
          <div className="text-center">
            <div className="fs-4 fw-bold text-success">{stats.thisWeek}</div>
            <small >This Week</small>
          </div>
          <div className="text-center">
            <div className="fs-4 fw-bold text-success">{stats.thisMonth}</div>
            <small >This Month</small>
          </div>
          <div className="text-center">
            <div className="fs-4 fw-bold text-warning">
              {stats.currentStreak}
            </div>
            <small >Day Streak</small>
          </div>
        </div>

        <div className="overflow-auto pb-2">
          <div className="d-flex gap-1" style={{ minWidth: 'max-content' }}>
            {weeks.map((week, weekIndex) => (
              <div key={weekIndex} className="d-flex flex-column gap-1">
                {week.map((day, dayIndex) => (
                  <div
                    key={dayIndex}
                    className="rounded"
                    style={{
                      width: '12px',
                      height: '12px',
                      backgroundColor: getColorForCount(day.count),
                      border: '1px solid rgba(255,255,255,0.1)',
                      cursor: 'pointer'
                    }}
                    title={`${day.date}: ${day.count} ${
                      day.count === 1 ? 'class' : 'classes'
                    }`}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end gap-2 mt-3">
          <small >Less</small>
          <div className="d-flex gap-1">
            <div
              className="rounded"
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.1)'
              }}
            />
            <div
              className="rounded"
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: 'rgba(34,197,94,0.4)'
              }}
            />
            <div
              className="rounded"
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: 'rgba(34,197,94,0.8)'
              }}
            />
          </div>
          <small >More</small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AttendanceHeatmapCard;
